import { useContext, useEffect } from 'react';
import { LoginWizardDescriptionContext } from '../context/LoginWizardDescriptionContext';

export function useLoginWizardDescription(description: string): void {
  const setDescription = useContext(LoginWizardDescriptionContext);

  useEffect(() => {
    if (!setDescription) return;
    setDescription(description);
    return () => setDescription(null);
  }, [description, setDescription]);
}
